import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Login from './pages/Auth/Login';
import Daftar from './pages/Auth/Daftar';
import Document from './pages/Dokumen/Dokumen';
import PdfViewer from './pages/Dokumen/PdfViewer'; 
import Kartu from './pages/Kartu/Kartu'; 
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Profil from './pages/Profil/Profil'; 
import Reset from './pages/Password/Reset'; 
import ResetValidate from './pages/Password/ResetValidate';
import NewPassword from './pages/Password/NewPassword';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/daftar" element={<Daftar />} />
        <Route path="/forgot-password" element={<Reset />} />
        <Route path="/forgot-password-validate" element={<ResetValidate />} />
        <Route path="/reset-password" element={<NewPassword />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout>
                <Home />
              </Layout>
            </PrivateRoute>
          }
        />
         <Route 
          path="/profil" 
          element={
            <PrivateRoute>
              <Layout title="Profil" subtitle="Update Data"><Profil /></Layout>
            </PrivateRoute>
          } 
        />
        <Route
          path="/document"
          element={
            <PrivateRoute>
              <Layout title="Rukun" subtitle="Materi Rukun">
                <Document />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route 
          path="/pdf-viewer" 
          element={
            <PrivateRoute>
              <Layout title="PDF" subtitle="PDF Viewer"><PdfViewer /></Layout>
            </PrivateRoute>
          } 
        />
        <Route 
          path="/kartu" 
          element={
            <PrivateRoute>
              <Layout title="Kartu" subtitle="Kartu Andar"><Kartu /></Layout>
            </PrivateRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
